import { LOAD_INFO } from '../actions.type';

export function loadInfo(info) {
  return {
    type: LOAD_INFO,
    info
  };
}



// WEBPACK FOOTER //
// ./src/redux/info/info.actions.js